import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@fortem-monorepo/js-utilities';
export const Spinner = ({ size, className, ...props }) => {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: size ?? 24, height: size ?? 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: cn('animate-spin', className), ...props, children: _jsx("path", { d: "M21 12a9 9 0 1 1-6.219-8.56" }) }));
};
